export default "__VITE_ASSET__D9U2pN2___"